import React, { useCallback, useState } from 'react';
import { AdvancedMarker, InfoWindow, Pin, useAdvancedMarkerRef } from '@vis.gl/react-google-maps';

import Icon, { faLocationDot, faStreetView } from '~components/icon';

import { Marker } from './common';

const RouteMarker: React.FC<Marker> = ({ type, orderId, data }) => {
  const [openWindow, setOpenWindow] = useState<number | null>(null);
  const [markerRef, marker] = useAdvancedMarkerRef();

  const handleClick = useCallback((id: number) => {
    setOpenWindow((prev) => (prev === id ? null : id));
  }, []);

  const handleClose = useCallback(() => {
    setOpenWindow(null);
  }, []);

  if (!Number.isFinite(data?.latitude) || !Number.isFinite(data?.longitude)) {
    return null;
  }

  let icon = faLocationDot;
  let colours = {
    backgroundColour: '#ffffff',
    glyphColour: '#000000',
    borderColour: '#000000',
  };

  if (type === 'client') {
    colours = {
      backgroundColour: '#40a13dff',
      glyphColour: '#ffffffff',
      borderColour: '#000000',
    };

    icon = faStreetView;
  }

  return (
    <>
      <AdvancedMarker
        key={`marker-${orderId}`}
        ref={markerRef}
        position={{ lat: data.latitude, lng: data.longitude }}
        clickable={true}
        onClick={() => handleClick(orderId)}
        className="location-pin"
      >
        <Pin background={colours.backgroundColour} glyphColor={colours.glyphColour} borderColor={colours.borderColour}>
          <Icon icon={icon} />
        </Pin>
      </AdvancedMarker>
      {openWindow === orderId && (
        <InfoWindow className="info-panel" anchor={marker} onClose={handleClose}>
          <span className="title">{type === 'client' ? `Client: ${data.name}` : `Origin: ${data.name}`}</span>
        </InfoWindow>
      )}
    </>
  );
};

export default RouteMarker;
